// Toolbar extension for BIMSearch viewer
// includes:
//      Custom Parameters Button - BIM Search parameters draggable menu.

export function ToolbarExtension(viewer, options) {
    window.Autodesk.Viewing.Extension.call(this, viewer, options);
}

ToolbarExtension.prototype = Object.create(window.Autodesk.Viewing.Extension.prototype);
ToolbarExtension.prototype.constructor = ToolbarExtension;
ToolbarExtension.prototype.TimebarOpenMethod = null;
ToolbarExtension.prototype.TimebarCloseMethod = null;
ToolbarExtension.prototype.TimebarButton = null;
ToolbarExtension.prototype.CustomParametersButton = null;
ToolbarExtension.prototype.CustomParametersButtonOnClickMethods = null;
ToolbarExtension.prototype.CustomParametersButtonRightClickMenuLabel = "BIMSearch properties";
/*
ToolbarExtension.prototype.load = function () {
console.log("********** loading evil UI");
    if (this.viewer.toolbar) {
        this.createUI();
    } else {
        this.onToolbarCreatedBinded = this.onToolbarCreated.bind(this);
        this.viewer.addEventListener(window.Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreatedBinded);
    }

    return true;
};
*/

ToolbarExtension.prototype.onToolbarCreated = function () {
    //this.viewer.removeEventListener(window.Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.onToolbarCreatedBinded);
    //this.onToolbarCreatedBinded = null;
    this.createUI();

};


ToolbarExtension.prototype.createUI = function () {

    let viewer = this.viewer;

    const customParametersButton = new window.Autodesk.Viewing.UI.Button('adsk-toolbar-extension-custom-parameters-button');
    customParametersButton.addClass('adsk-toolbar-extension-custom-parameters-button');

    customParametersButton.setToolTip('Custom Parameters');

    customParametersButton.onClick = async function (e) {
        // registered in CustomParametersButtonOnClickMethods property are:
        // a react useState setter         - setCustomParametersDraggable
        // redux dispatch                  - dispatch
        // an action to pass to dispatch   - getParametersOfSelectedElements
        const { setCustomParametersDraggable, dispatch, getParametersOfSelectedElements } = ToolbarExtension.prototype.CustomParametersButtonOnClickMethods
        
        // Button.State = {
        //     ACTIVE: 0,
        //     INACTIVE: 1,
        //     DISABLED: 2
        //   };
        if (!customParametersButton.getState()) {
            customParametersButton.setState(1)
        } else {
            customParametersButton.setState(0)
            dispatch(getParametersOfSelectedElements())
        }
        setCustomParametersDraggable(prev => !prev)
    }

    customParametersButton.setToolTip('BIMSearch Properties');
    const timebarButton = new window.Autodesk.Viewing.UI.Button('adsk-toolbar-extension-timevar-button');
    timebarButton.addClass('adsk-toolbar-extension-timevar-button');

    timebarButton.setToolTip('Timebar');

    timebarButton.onClick = async function (e) {
        
        // Button.State = {
        //     ACTIVE: 0,
        //     INACTIVE: 1,
        //     DISABLED: 2
        //   };
        if (!timebarButton.getState()) {
            timebarButton.setState(1);
            ToolbarExtension.prototype.TimebarCloseMethod();
        } else {
            timebarButton.setState(0);
            ToolbarExtension.prototype.TimebarOpenMethod();
        }
    }

    this.subToolbar = new window.Autodesk.Viewing.UI.ControlGroup('custom-tools');
    this.subToolbar.addControl(customParametersButton);

    this.timebarToolbar = new window.Autodesk.Viewing.UI.ControlGroup('timebar');
    this.timebarToolbar.addControl(timebarButton);

    // save button to use from outside
    ToolbarExtension.prototype.CustomParametersButton = customParametersButton;
    ToolbarExtension.prototype.TimebarButton = timebarButton;

    viewer.toolbar.addControl(this.subToolbar);
    viewer.toolbar.addControl(this.timebarToolbar);
};


ToolbarExtension.prototype.unload = function () {

    this.viewer.toolbar.removeControl(this.subToolbar);
    return true;

};

window.Autodesk.Viewing.theExtensionManager.registerExtension('ToolbarExtension', ToolbarExtension);

